import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faChevronRight, faLayerGroup } from '@fortawesome/free-solid-svg-icons';

interface ServiceBreadcrumbProps {
    currentPage: string;
    showBackButton?: boolean;
}

const ServiceBreadcrumb: React.FC<ServiceBreadcrumbProps> = ({ currentPage, showBackButton = true }) => {
    const location = useLocation();
    
    const getBreadcrumbItems = () => {
        const pathSegments = location.pathname.split('/').filter(Boolean);
        const items = [];
        
        // Always start with home
        items.push({
            name: 'Home',
            path: '/institution/home',
            icon: faHome
        });
        
        // Add service center
        items.push({
            name: 'Service Center',
            path: '/institution/service-lander',
            icon: faLayerGroup
        });
        
        // Add current page if it's not the service center
        if (currentPage !== 'Service Center') {
            items.push({
                name: currentPage,
                path: location.pathname,
                icon: null,
                isCurrent: true
            });
        }
        
        return items;
    };
    
    const breadcrumbItems = getBreadcrumbItems();
    
    return (
        <div className="d-flex align-items-center justify-content-between mb-4">
            {/* Breadcrumb Navigation */}
            <nav aria-label="breadcrumb">
                <ol className="breadcrumb mb-0">
                    {breadcrumbItems.map((item, index) => (
                        <li key={index} className={`breadcrumb-item ${item.isCurrent ? 'active' : ''}`}>
                            {item.isCurrent ? (
                                <span className="text-muted">{item.name}</span>
                            ) : (
                                <Link 
                                    to={item.path} 
                                    className="text-decoration-none d-flex align-items-center"
                                    style={{ color: '#6c757d' }}
                                >
                                    {item.icon && <FontAwesomeIcon icon={item.icon} className="me-1" size="sm" />}
                                    {item.name}
                                </Link>
                            )}
                            {index < breadcrumbItems.length - 1 && (
                                <FontAwesomeIcon icon={faChevronRight} className="mx-2 text-muted" size="xs" />
                            )}
                        </li>
                    ))}
                </ol>
            </nav>
            
            {/* Back to Service Center Button */}
            {showBackButton && currentPage !== 'Service Center' && (
                <Link 
                    to="/institution/service-lander" 
                    className="btn btn-outline-primary btn-sm"
                >
                    <FontAwesomeIcon icon={faLayerGroup} className="me-2" />
                    Back to Service Center
                </Link>
            )}
        </div>
    );
};

export default ServiceBreadcrumb;
